import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarProvider, useSidebar } from '../../context/SidebarContext';
import { PageTitleProvider } from '../../context/PageTitleContext';
import Sidebar from './Sidebar';
import TopNavbar from './TopNavbar';
import './Layout.css';

const LayoutContent = () => {
  const { isOpen, isMobile, closeSidebar } = useSidebar();

  // Close sidebar on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        closeSidebar();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, closeSidebar]);

  // Close sidebar when window is resized to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991 && isOpen && isMobile) {
        closeSidebar();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isOpen, isMobile, closeSidebar]);

  return (
    <div className="app-container">
      <Sidebar />
      <div className={`main-content ${isOpen && isMobile ? 'sidebar-open' : ''}`}>
        <TopNavbar />
        <main className="page-content" onClick={() => isMobile && isOpen && closeSidebar()}>
          <Outlet />
        </main>
        <footer className="app-footer">
          <p>&copy; 2024 Haughton Elevators - Professional Elevator Management v2.0</p>
        </footer>
      </div>
    </div>
  );
};

const Layout = () => {
  return (
    <SidebarProvider>
      <PageTitleProvider>
        <LayoutContent />
      </PageTitleProvider>
    </SidebarProvider>
  );
};

export default Layout;
